// src/services/objectifsServices.js
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/objectifs`;
const apiBase = `${process.env.REACT_APP_API_URL}`;
const token = localStorage.getItem("token");
const auth = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};

/// GET
// Tous les objectifs (tu peux passer des filtres en query: { adherent_id, saison, type, is_done, q })
export const getAllObjectifs = async (filters = {}) => {
  try {
    const response = await axios.get(`${apiUrl}/all`, {
      ...auth,
      params: filters,
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des objectifs :", error);
    throw error;
  }
};

// Un objectif par ID
export const getObjectifById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/${id}`, auth);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération de l'objectif :", error);
    throw error;
  }
};

// Tous les objectifs d'un adhérent
export const getObjectifsByAdherent = async (adherentId, filters = {}) => {
  try {
    const response = await axios.get(
      `${apiBase}/api/adherents/${adherentId}/objectifs`,
      { ...auth, params: filters }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des objectifs de l'adhérent :",
      error
    );
    throw error;
  }
};

/// POST
// Créer un objectif
export const createObjectif = async (objectifData) => {
  try {
    console.log("[API] POST /api/objectifs/create", objectifData);
    const response = await axios.post(`${apiUrl}/create`, objectifData, auth);
    console.log("[API] OK /api/objectifs/create ->", response.data);
    return response.data;
  } catch (error) {
    console.error("[API] ERR /api/objectifs/create", error?.response || error);
    throw error;
  }
};

/// PUT
// Mettre à jour un objectif
export const updateObjectif = async (id, objectifData) => {
  try {
    const response = await axios.put(
      `${apiUrl}/update/${id}`,
      objectifData,
      auth
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de l'objectif :", error);
    throw error;
  }
};

/// PATCH
// Mettre à jour la progression (0..100)
export const setObjectifProgress = async (id, progress) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/${id}/progress`,
      { progress },
      auth
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour de la progression :", error);
    throw error;
  }
};

// Marquer terminé / non terminé
export const setObjectifDone = async (id, is_done) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/${id}/done`,
      { is_done },
      auth
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification du statut is_done :", error);
    throw error;
  }
};

/// DELETE
// Supprimer un objectif
export const deleteObjectif = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/delete/${id}`, auth);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de l'objectif :", error);
    throw error;
  }
};
